function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { j as i } from "./index.es33.js";
import { useRef as y, useState as E, useEffect as u } from "react";
import { clsx as B } from "./index.es105.js";
import { useClickAway as H } from "./index.es130.js";
import { ENTER_KEY_CODE as R } from "./index.es131.js";
import { BaseInput as b } from "./index.es62.js";
import { Select as F } from "./index.es17.js";
import "./index.es106.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import "./index.es36.js";
import "./index.es19.js";
import "nanoid";
import "./index.es132.js";
import "./index.es7.js";
import "./index.es133.js";
import "react-dom";
import "./index.es134.js";
import "./index.es13.js";
import "./index.es15.js";
import "./index.es42.js";
import "./index.es135.js";
import "./index.es136.js";
import "./index.es137.js";
import "./index.es5.js";
import a from "./index.es138.js";

var ce = function ce(r) {
  var o = y(null),
      n = y(null),
      _E = E(!1),
      _E2 = _slicedToArray(_E, 2),
      c = _E2[0],
      d = _E2[1],
      _E3 = E(!1),
      _E4 = _slicedToArray(_E3, 2),
      s = _E4[0],
      m = _E4[1],
      l = r.submitHandler,
      t = r.value,
      p = r.items,
      _r$submitOnBlur = r.submitOnBlur,
      f = _r$submitOnBlur === void 0 ? !0 : _r$submitOnBlur,
      j = r.isLarge,
      T = r.onChange;

  H(o, function () {
    return m(!1);
  });

  var g = function g(e) {
    var _n$current;

    t && !p.includes(t) && e.key === R && (f ? (_n$current = n.current) === null || _n$current === void 0 ? void 0 : _n$current.blur() : l === null || l === void 0 ? void 0 : l(t));
  },
      h = function h(e) {
    c || d(!0), T === null || T === void 0 ? void 0 : T(e);
  };

  u(function () {
    r.isTriggered && n.current.focus();
  }, [r.isTriggered]);

  var k = function k(e) {
    if (o.current) {
      var _e$relatedTarget, _e$relatedTarget2, _r$onBlur;

      var C = Array.from(o.current.children).some(function (w) {
        return w.contains(e.relatedTarget);
      });
      C ? (h(((_e$relatedTarget = e.relatedTarget) === null || _e$relatedTarget === void 0 ? void 0 : _e$relatedTarget.textContent) || ""), l !== null && l !== void 0 && l(((_e$relatedTarget2 = e.relatedTarget) === null || _e$relatedTarget2 === void 0 ? void 0 : _e$relatedTarget2.textContent) || ""), m(!1)) : (_r$onBlur = r.onBlur) === null || _r$onBlur === void 0 ? void 0 : _r$onBlur.call(r, e), t && !p.includes(t) && f && !C && l(t);
    }
  },
      x = p.filter(function (e) {
    return c ? e.includes(t || "") : e;
  });

  return u(function () {
    s || d(!1);
  }, [s]), u(function () {
    return document.addEventListener("keydown", g), function () {
      document.removeEventListener("keydown", g);
    };
  }, [t]), i.jsxs("div", {
    className: B(a.inputWrapper, _defineProperty({}, a.largeInput, j)),
    onFocus: function onFocus() {
      return m(!0);
    },
    ref: o,
    children: [i.jsx(b, _objectSpread(_objectSpread({}, r), {}, {
      ref: n,
      onBlur: k,
      onChange: h
    })), !!x.length && s && i.jsx("ul", {
      className: a.optionsListPopup,
      children: x.map(function (e) {
        return i.jsx(F.Option, {
          isSelected: t === e,
          children: e
        }, e);
      })
    })]
  });
};

export { ce as History };